export enum DBSTypes {
	Basic = "Basic",
	Standard = "Standard",
	Enhanced = "Enhanced",
	EnhancedBarredList = "Enhanced with Barred List",
	ChildWorkforce = "Child workforce",
	ChildAndAdultWorkforce = "Child and adult workforce",
	AdultWorkforce = "Adult workforce",
}
